import React, { useState } from 'react';
import { Container, Row, Col, Card, FormGroup, Label, Input, Button, CardBody } from 'reactstrap';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { usePendingWork } from '../../../hooks/workOrder/usePendingWork';
import Select from 'react-select';
import './styleDataTable.css';


export const IndexPendingWork = () => {
    const {
        // #region Filters
        branches, mDateRange1, mDateRange2, mSelectBranch,
        // #endregion 

        handleInputChange, handleSelectValues, loading,
        getPedingWork, reportPendingExams, handleClean,
        sections, mSelectSections,

        //Indicators
        totalExam, totalExamsReleased, totalPendingExams, pendingExamsPercentage,

        // search Exams
        handleSearchPedingWork, handleCleanWork


    } = usePendingWork();

    const [expandedRows, setExpandedRows] = useState(null);
    
    const rowExpansionTemplate = (data) => {

        const pendingNims = data.pending_nims || [];

        const handleOpenNim = () => {
            const sectionsOriginales = JSON.parse(
                localStorage.getItem("sections") || "[]"
            );

            const filtrosRestaurados = sectionsOriginales.map(id => ({
                id_section: id
            }));

            localStorage.setItem(
                "filter_sections",
                JSON.stringify(filtrosRestaurados)
            );
        };

        return (
            <div className="pending-nims-container">

                <div className="pending-nims-header">
                    <div className="pending-nims-heading">
                        <div className="pending-nims-icon">
                            <i className="fa fa-list-alt"></i>
                        </div>

                        <div className="pending-nims-heading-text">
                            <span className="pending-nims-title">
                                NIMs pendientes
                            </span>
                            <span className="pending-nims-subtitle">
                                Registros pendientes de liberar
                            </span>
                        </div>
                    </div>

                    <span className="pending-nims-count">
                        {pendingNims.length} registros
                    </span>
                </div>

                {pendingNims.length > 0 ? (
                    <div className="pending-nims-grid">
                        {pendingNims.map((nim, index) => (
                            <a
                                key={`${nim}-${index}`}
                                href={`/captura-resultados/${nim}`}
                                target="_blank"
                                rel="noopener noreferrer"
                                onClick={handleOpenNim}
                                className="pending-nim-item"
                                title={`Consultar resultados del NIM ${nim}`}
                            >
                                <i className="fa fa-file-text-o pending-nim-file"></i>

                                <span className="pending-nim-number">
                                    {nim}
                                </span>

                                <i className="fa fa-external-link pending-nim-link"></i>
                            </a>
                        ))}
                    </div>
                ) : (
                    <div className="pending-nims-empty">
                        <i className="fa fa-check-circle-o"></i>
                        <span>No hay NIMs pendientes</span>
                    </div>
                )}

            </div>
        );
    };

    const headerStyle = {
        backgroundColor: "#1d5b83",
        color: "#fff",
        fontWeight: "bold",
        fontSize: "12px",
        borderRight: "1px solid #fff",
        borderBottom: "2px solid #fff",
    };

    const cellStyle = {
        fontSize: "12px",
        padding: "5px",
        textAlign: "center",
        fontFamily: "Montserrat, sans-serif",

    };

    const centerStyle = {
        ...cellStyle,
        textAlign: "center",
    };


    return (
        <div className='container-global-zoom'>

            <Card style={{
                marginBottom: '15px',
                background: 'linear-gradient(135deg, #002940 0%, #1d5b83 100%)',
                border: 'none',
                boxShadow: '0 4px 12px rgba(0,0,0,0.15)'
            }}>
                <CardBody style={{ padding: '18px 25px' }}>
                    <div className="d-flex align-items-center justify-content-between">
                        <div className="d-flex align-items-center">
                            <div style={{
                                width: '50px',
                                height: '50px',
                                borderRadius: '12px',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                marginRight: '15px'
                            }}>
                                <img alt="flask" className="img-fluid text-info mr-2" src={require("../../../assets/images/pendingWork/pendingWork.png")} style={{ width: "45px", height: "45px" }} />
                            </div>
                            <div>
                                <h4 className="mb-1" style={{ color: '#fff', fontWeight: 700, fontSize: '20px', textAlign: "justify" }}>
                                    Trabajo Pendiente
                                </h4>
                                <small style={{ color: 'rgba(255,255,255,0.85)', fontSize: '13px' }}>
                                    <i className="fa fa-info-circle mr-1"></i>
                                    Consulta de trabajos pendientes por área y periodo.
                                </small>
                            </div>
                        </div>

                    </div>
                </CardBody>
            </Card>

            <Card className="shadow-sm border height-equal pricingtable mb-0 pb-0" style={{ padding: "5px", width: "100%" }}>
                <Col sm="12">
                    <Card className="pending-filters-card">
                        <div className="pending-filters-header">
                            <div className="pending-filters-header-title">
                                <i className="fa fa-filter"></i>
                                <span>Filtros de búsqueda</span>
                            </div>
                        </div>

                        <CardBody className="pending-filters-body">

                            <div className="pending-filters-row">
                                <FormGroup className="pending-filter-group">
                                    <Label className="pending-filter-label">
                                        <i className="fa fa-calendar"></i>
                                        Fecha de inicio
                                    </Label>

                                    <Input
                                        type="date"
                                        value={mDateRange1}
                                        name="mDateRange1"
                                        onChange={handleInputChange}
                                        className="pending-filter-input"
                                    />
                                </FormGroup>

                                <FormGroup className="pending-filter-group">
                                    <Label className="pending-filter-label">
                                        <i className="fa fa-calendar-check-o"></i>
                                        Fecha de cierre
                                    </Label>

                                    <Input
                                        type="date"
                                        value={mDateRange2}
                                        name="mDateRange2"
                                        onChange={handleInputChange}
                                        className="pending-filter-input"
                                    />
                                </FormGroup>

                                <FormGroup className="pending-filter-group">
                                    <Label className="pending-filter-label">
                                        <i className="fa fa-map-marker"></i>
                                        Sucursales
                                    </Label>

                                    <Select
                                        name="mSelectBranch"
                                        placeholder="Selecciona una sucursal"
                                        options={branches}
                                        value={mSelectBranch}
                                        onChange={(e) => handleSelectValues(e, 'mSelectBranch')}
                                        menuPortalTarget={document.body}
                                        styles={{
                                            menuPortal: (base) => ({
                                                ...base,
                                                zIndex: 99999
                                            }),
                                            control: (base, state) => ({
                                                ...base,
                                                minHeight: "30px",
                                                height: "30px",
                                                borderRadius: "6px",
                                                borderColor: state.isFocused
                                                    ? "#1d5b83"
                                                    : "#cbd8e3",
                                                boxShadow: "none",
                                                fontSize: "11px",
                                                "&:hover": {
                                                    borderColor: "#1d5b83"
                                                }
                                            }),
                                            valueContainer: (base) => ({
                                                ...base,
                                                height: "28px",
                                                padding: "0 8px"
                                            }),
                                            indicatorsContainer: (base) => ({
                                                ...base,
                                                height: "28px"
                                            }),
                                            dropdownIndicator: (base) => ({
                                                ...base,
                                                padding: "5px"
                                            }),
                                            clearIndicator: (base) => ({
                                                ...base,
                                                padding: "5px"
                                            }),
                                            input: (base) => ({
                                                ...base,
                                                margin: 0,
                                                padding: 0
                                            })
                                        }}
                                    />
                                </FormGroup>

                                {/* ACCIONES */}
                                <div className="pending-filter-actions">

                                    <Label className="pending-filter-label">
                                        <i className="fa fa-cog"></i>
                                        Acciones
                                    </Label>

                                    <div className="pending-filter-buttons">
                                        <Button
                                            type="button"
                                            color="primary"
                                            outline
                                            disabled={loading}
                                            onClick={(e) => getPedingWork(e, true)}
                                            className="pending-btn-search"
                                        >
                                            {loading ? (
                                                <>
                                                    <i className="pi pi-spin pi-spinner me-2"></i>
                                                    Buscando...
                                                </>
                                            ) : (
                                                'Buscar'
                                            )}
                                        </Button>

                                        <Button
                                            type="button"
                                            color="danger"
                                            outline
                                            disabled={loading}
                                            onClick={handleClean}
                                            className="pending-btn-clear"
                                        >
                                            <i className="fa fa-eraser mr-1"></i>
                                            Limpiar
                                        </Button>
                                    </div>
                                </div>
                            </div>
                        </CardBody>
                    </Card>
                </Col>

                {
                    // * GLOBAL INDICATORS
                }
                <Col sm="12">
                    <Row className="mb-3 report-kpi-row">
                        <Col sm="3">
                            <div className="report-kpi report-kpi-blue">
                                <div className="report-kpi-decoration"></div>
                                <div className="report-kpi-info">
                                    <div className="report-kpi-title">
                                        <span className="report-kpi-dot"></span>
                                        Examenes
                                    </div>

                                    <div className="report-kpi-number">
                                        {
                                            loading && <i className="fa fa-spin fa-spinner font-primary f-24"></i>
                                        }
                                        {
                                            <div>
                                                {!loading && totalExam()}
                                            </div>
                                        }
                                    </div>

                                    <div className="report-kpi-footer">
                                        <i className="fa fa-file-text-o"></i>
                                            Total de Exámenes
                                    </div>
                                </div>

                                <div className="report-kpi-icon">
                                    <i className="fa fa-flask"></i>
                                </div>
                            </div>
                        </Col>

                        <Col sm="3">
                            <div className="report-kpi report-kpi-green">
                                <div className="report-kpi-decoration"></div>
                                <div className="report-kpi-info">
                                    <div className="report-kpi-title">
                                        <span className="report-kpi-dot"></span>
                                        Liberados
                                    </div>

                                    <div className="report-kpi-number">
                                        {
                                            loading && <i className="fa fa-spin fa-spinner font-primary f-24"></i>
                                        }
                                        {
                                            <div>
                                                {!loading && totalExamsReleased()}
                                            </div>
                                        }
                                    </div>

                                    <div className="report-kpi-footer">
                                        <i className="fa fa-check-circle-o"></i>
                                        Examenes liberados
                                    </div>
                                </div>

                                <div className="report-kpi-icon">
                                    <i className="fa fa-check-circle"></i>
                                </div>
                            </div>
                        </Col>

                        <Col sm="3">
                            <div className="report-kpi report-kpi-orange">
                                <div className="report-kpi-decoration"></div>
                                <div className="report-kpi-info">
                                    <div className="report-kpi-title">
                                        <span className="report-kpi-dot"></span>
                                        Pendientes
                                    </div>

                                    <div className="report-kpi-number">
                                        {
                                            loading && <i className="fa fa-spin fa-spinner font-primary f-24"></i>
                                        }
                                        {
                                            <div>
                                                {!loading && totalPendingExams()}
                                            </div>
                                        }

                                    </div>

                                    <div className="report-kpi-footer">
                                        <i className="fa fa-line-chart"></i>
                                        Exámenes Pendientes
                                    </div>
                                </div>

                                <div className="report-kpi-icon">
                                    <i className="fa fa-clock-o"></i>
                                </div>
                            </div>
                        </Col>

                        <Col sm="3">
                            <div className="report-kpi report-kpi-purple">
                                <div className="report-kpi-decoration"></div>
                                <div className="report-kpi-info">
                                    <div className="report-kpi-title">
                                        <span className="report-kpi-dot"></span>
                                        Cumplimiento
                                    </div>

                                    <div className="report-kpi-number">
                                        {
                                            loading && <i className="fa fa-spin fa-spinner font-primary f-24"></i>
                                        }
                                        {
                                            <div>
                                                {!loading && pendingExamsPercentage()}%
                                            </div>
                                        }

                                    </div>

                                    <div className="report-kpi-footer">
                                        <i className="fa fa-percent"></i>
                                        Porcentaje de cumplimiento
                                    </div>
                                </div>

                                <div className="report-kpi-icon">
                                    <i className="fa fa-percent"></i>
                                </div>
                            </div>
                        </Col>
                    </Row>
                </Col>

                <Col sm="12" className="pt-3">
                    <Row>
                        { 
                            //* SECTIONS
                        }
                        <Col sm="4">
                            <Card className="reference-labs-card">
                                <div className="reference-labs-header">
                                    <div className="reference-labs-heading">
                                        <i className="fa fa-building-o"></i>
                                        <span>Secciones   </span>
                                    </div>

                                    <button
                                        type="button"
                                        className="reference-labs-clear"
                                        onClick={(e) => {e.stopPropagation(); handleCleanWork(); }}
                                        title="Limpiar selección"
                                    >
                                        <i className="fa fa-eraser"></i>
                                    </button>
                                </div>

                                <CardBody className="reference-labs-body">

                                    <div className="reference-labs-summary">
                                        <span>Selecciona una sections</span>

                                        <span className="reference-labs-count">
                                            {sections.length} disponibles
                                        </span>
                                    </div>

                                    {sections.length > 0 ? (
                                        <div className="reference-labs-grid">

                                            {sections.map((section) => {

                                                const isSelected =
                                                    mSelectSections?.value ===
                                                    section.value;

                                                return (
                                                    <button
                                                        type="button"
                                                        key={section.value}
                                                        title={section.label}
                                                        aria-pressed={isSelected}
                                                        className={`reference-labs-item ${
                                                            isSelected ? "is-selected" : ""
                                                        }`}
                                                        onClick={() => {
                                                            handleSelectValues(
                                                                section,
                                                                "mSelectSections"
                                                            );
                                                        }}
                                                    >
                                                        {isSelected && (
                                                            <i className="fa fa-check-circle"></i>
                                                        )}

                                                        <span>{section.label}</span>
                                                    </button>
                                                );
                                            })}

                                        </div>
                                    ) : (
                                        <div className="reference-labs-empty">
                                            <i className="fa fa-building-o"></i>
                                            <span>
                                                No hay secciones disponibles
                                            </span>
                                        </div>
                                    )}

                                </CardBody>
                            </Card>
                        </Col>

                        { 
                            //* TABLE
                        }
                        <Col sm="8">
                            <div className="report-table-card">
                                <div className="report-table-toolbar">
                                    <div className="report-table-title">
                                        <div className="report-table-title-icon">
                                            <i className="fa fa-list-ul"></i>
                                        </div>

                                        <div>
                                            <h5>Detallado de trabajos pendientes</h5>
                                        </div>
                                    </div>

                                    <div className="report-table-actions">
                                        <div className="report-general-search">
                                            <i className="pi pi-search"></i>

                                            <Input
                                                type="search"
                                                placeholder="Buscar en todos los registros..."
                                                // value={searchTerm}
                                                onChange={handleSearchPedingWork}
                                            />
                                        </div>
                                    </div>
                                </div>

                                <div className='table-responsive'>
                                    <DataTable
                                        value={reportPendingExams}
                                        loading={loading}
                                        responsiveLayout="scroll"
                                        expandedRows={expandedRows}
                                        onRowToggle={(e) => setExpandedRows(e.data)}
                                        rowExpansionTemplate={rowExpansionTemplate}
                                        paginator
                                        rows={10}
                                        rowsPerPageOptions={[10, 16, 24, 50]}
                                        className='data-table p-datatable-striped p-datatable-sm'

                                        emptyMessage={
                                            <div className="text-center">
                                                <img
                                                    src={require("../../../assets/images/loginHelenLabs/dashboard/recepcionista.svg")}
                                                    style={{ width: "35%" }}
                                                    alt="Sin resultados"
                                                />
                                                <br />
                                                <p className='badge badge-light-primary mt-2' style={{ fontSize: "15px" }}>
                                                    No hay coincidencias con la búsqueda.
                                                </p>
                                            </div>
                                        }
                                    >
                                        <Column expander frozen headerStyle={headerStyle} style={centerStyle} />
                                        <Column header="#" body={(rowData, options) => { const globalIndex = options.rowIndex; return globalIndex + 1; }} headerStyle={headerStyle} style={centerStyle} />

                                        <Column field="name" header="Nombre" sortable headerStyle={headerStyle} style={centerStyle} />
                                        <Column field="num_exams" header="Total de Exámenes" sortable headerStyle={headerStyle} style={centerStyle} />
                                        <Column field="num_exams_released" header="Exámenes Liberados" sortable headerStyle={headerStyle} style={centerStyle} />
                                        <Column field="pendingExams" header="Exámenes Pendientes" sortable headerStyle={headerStyle} style={centerStyle} />
                                    </DataTable>
                                </div>
                            </div>
                        </Col>
                    </Row>
                </Col>
            </Card>
            <br /><br />
        </div>
    );
};









